export interface FormDetailsSectionHeaderConfig {
  defaultIconNumber: number;
  title: string;
  warningSubtitle?: string;
}

export enum FormDetailsSectionHeaderIconType {
  Default = "default",
  Changes = "changes",
  Warning = "warning",
}

export interface FormDetailsSectionBlockedData {
  reason?: string
  isBlocked?: boolean
  isUnblockingInProgress?: boolean;
}
